import styled from 'styled-components';

export const PresenterIconWrap = styled.div`
  opacity: 0.85;
`;

export const PresenterTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
`;

export const PresenterSubtitle = styled.div`
  font-size: 14px;
  opacity: 0.7;
`;

export const MainFooterStrip = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: linear-gradient(180deg, rgba(7, 23, 36, 0) 0%, rgba(7, 23, 36, 0.78) 100%);
  color: #fff;
  padding: 18px 12px 10px;
  font-size: 13px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0,0,0,0.45);
  pointer-events: none;
`;
